export const TASK_STATUS = {
  not_started: "Not Started",
  in_progress: "In Progress",
  completed: "Completed",
};

export const STUDENT_LEVELS = {
  FREE_TRAINEE: "free_trainee",
  PAID_TRAINEE: "paid_trainee",
  INTERN: "intern",
  EMPLOYEE: "employee",
};

export const USER_ROLES = {
  ADMIN: "admin",
  TUTOR: "tutor",
  STUDENT: "student",
};
